import { APIClient } from '@/data/APIClient'

export class ThemeAction {
  /**
   */
  static theme () {
    return APIClient.client.get('/settings', {})
  }
}
